export function parseFullCrosswordPuzzle(json) {
  const grid = (json.grid || []).map((row) =>
    row.map((cell) => String(cell).toUpperCase())
  );
  return {
    id: json.id,
    title: json.title,
    rows: json.rows,
    cols: json.cols,
    solution: grid,
    // Word square (daily v1) clues
    rowWords: (json.rowWords || []).map(String),
    colWords: (json.colWords || []).map(String),
    rowClues: (json.rowClues || []).map(String),
    colClues: (json.colClues || []).map(String),
    license: json.license || null,

    // Backwards compatibility (bundled sample may still provide these)
    acrossClues: (json.acrossClues || []).map(String),
    downClues: (json.downClues || []).map(String),
  };
}

export function isBlackCell(puzzle, row, col) {
  const ch = puzzle.solution[row][col];
  return ch === '.' || ch === '#' || ch === ' ';
}

export function isCompleteAndCorrect(puzzle, userLetters) {
  const { rows, cols, solution } = puzzle;
  if (userLetters.length !== rows) return false;
  for (let r = 0; r < rows; r++) {
    if (userLetters[r].length !== cols) return false;
    for (let c = 0; c < cols; c++) {
      if (isBlackCell(puzzle, r, c)) continue;
      const u = (userLetters[r][c] || '').trim().toUpperCase();
      const sol = solution[r][c].toUpperCase();
      if (u.length !== 1 || u !== sol) return false;
    }
  }
  return true;
}

/** Higher score = faster completion (matches Flutter). */
export function fullCrosswordScoreFromSeconds(elapsedSeconds) {
  const s = Math.min(Math.max(0, elapsedSeconds), 99999);
  return Math.min(Math.max(0, 100000 - s), 100000);
}
